module.exports = __webpack_public_path__ + "static/kids_friendly_corp-00f97e246646bcfb3867dab9fe6e9da4.jpg";